/*jshint esversion: 8 */
import { fetchPost } from './RequestHandler';


// 查询所有市场
const getAllMarkets = async (data) => {
  const rst = await fetchPost('/web_market/getAllMarkets', { data });
  return rst;
};

// 更新市场信息
const updateMarket = async (data) => {
  const rst = await fetchPost('/web_market/updateMarket', { data });
  return rst;
};

// 删除市场
const deleteMarket = async (data) => {
  const rst = await fetchPost('/web_market/deleteMarket', { data });
  return rst;
};

// 新增市场
const addNewMarket = async (data) => {
  const rst = await fetchPost('/web_market/addNewMarket', { data });
  return rst;
};


export {
  getAllMarkets,
  updateMarket,
  deleteMarket,
  addNewMarket
};
